import React from "react";

const About = () => {
  return (
    <div className="about-container">
      <h2>About</h2>
    </div>
  );
};

export default About;
